import { render, staticRenderFns } from "./ClearCache.vue?vue&type=template&id=3967a9f5"
import script from "./ClearCache.vue?vue&type=script&lang=js"
export * from "./ClearCache.vue?vue&type=script&lang=js"
import style0 from "./ClearCache.vue?vue&type=style&index=0&id=3967a9f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports